import { isType } from '@ricoh/ria.client.core/utils/data/object';

import type { PatternAccessScope } from '~/common/logic/feature/settings/batch-type-library/pattern';
import type { FieldDataSource, FieldDataSourceAI, FieldDataSourceAuto } from '~/common/model/api/batch-type';

import type { FieldDataSourceFormField } from './_data-source.type';

import { createFieldDataSourceAIValue, createFieldDataSourceAIValueFormField } from './_ai';
import { createFieldDataSourceAutoValue, createFieldDataSourceAutoValueFormField } from './_auto';

/**
 * Create Field DataSource FormField.
 *
 * @param {FieldDataSource} dataSource Field DataSource.
 *
 * @returns {FieldDataSourceFormField} Field DataSource FormField.
 */
export function createFieldDataSourceFormField(dataSource: FieldDataSource): FieldDataSourceFormField {
  if (isType<FieldDataSourceAuto>(dataSource, 'auto')) {
    return {
      type: 'auto',
      value: createFieldDataSourceAutoValueFormField(dataSource),
    };
  }

  if (isType<FieldDataSourceAI>(dataSource, 'ai')) {
    return {
      type: 'ai',
      value: createFieldDataSourceAIValueFormField(dataSource),
    };
  }

  return {
    type: 'manual',
  };
}

/**
 * Create Field DataSource.
 *
 * @param {FieldDataSourceFormField} dataSource Field DataSource FormField.
 * @param {PatternAccessScope} scope Scope Pattern.
 *
 * @returns {FieldDataSource} Field DataSource.
 */
export function createFieldDataSource(dataSource: FieldDataSourceFormField, scope: PatternAccessScope): FieldDataSource {
  if (dataSource.type === 'auto') {
    return {
      $is: 'auto',
      value: createFieldDataSourceAutoValue(dataSource.value ?? [], scope),
    };
  }

  if (dataSource.type === 'ai') {
    return {
      $is: 'ai',
      ...createFieldDataSourceAIValue(dataSource.value ?? []),
    };
  }

  return {
    $is: 'manual',
  };
}
